<template>
  <div
    class="checkbox-square-wrap"
    @click="toggleCheck"
  >
    <div
      class="checkbox-square"
      :class="{
        nochecked: !value
      }"
    >
      <template v-if="value">
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <rect fill="#FFCA27" width="16" height="16" rx="2"/>
          <g transform="translate(0, 0)">
            <polygon id="done-icon" fill="#000000" points="13 5.60040333 8.32597504 10.4 6.76796672 12 5.2099584 10.4 5.21860714 10.3911268 3 8.08812705 4.55842016 6.48812705 6.77661546 8.79153012 11.4419917 4"></polygon>
          </g>
        </svg>
      </template>
    </div>

    <div class="label">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxSquare',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleCheck() {
      this.$emit('change', this.value)
    }
  }
}
</script>

<style lang="less" scoped>
.checkbox-square-wrap {
  display: flex;
  align-items: center;
  font-size: 12px;
  user-select: none;
}

.checkbox-square {
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  margin-right: 5px;

  svg {
    vertical-align: top;
  }

  &.nochecked {
    border: 1px solid #999;
    border-radius: 2px;
  }
}
</style>
